(function () {
 'use strict';

 // Shared countdown source of truth (mirrors assets/laboo-offer-bar-countdown.js)
 var STORAGE_KEY = 'laboo_sale_ends_target';
 var DURATION_MS = 6261 * 1000; // 1h 44m 21s

 var initialized = false;
 var intervalId = null;

 function readCookie(name) {
 var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
 return match ? decodeURIComponent(match[1]) : null;
 }

 function writeCookie(name, value, days) {
 var expires = '';
 if (days) {
 var d = new Date();
 d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
 expires = '; expires=' + d.toUTCString();
 }
 document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
 }

 function readStoredEnd() {
 var raw = null;
 try {
 raw = window.localStorage.getItem(STORAGE_KEY);
 } catch (e) {
 raw = null;
 }
 if (!raw) {
 raw = readCookie(STORAGE_KEY);
 }
 var end = parseInt(raw, 10);
 return isFinite(end) && end > 0 ? end : null;
 }

 function writeStoredEnd(end) {
 try {
 window.localStorage.setItem(STORAGE_KEY, String(end));
 } catch (e) {
 try {
 writeCookie(STORAGE_KEY, String(end), 365);
 } catch (e2) {}
 }
 }

 function pad2(n) {
 return n < 10 ? '0' + n : String(n);
 }

 function getModal() {
 return document.querySelector('[data-ls-promo-v2-modal]');
 }

 function getStrip() {
 return document.querySelector('.laboo-offer-strip');
 }

 function getUnit(name) {
 var modal = getModal();
 if (!modal) return null;
 return modal.querySelector('[data-ls-promo-v2-unit="' + name + '"]');
 }

 function isOpen() {
 var modal = getModal();
 return !!modal && modal.getAttribute('aria-hidden') === 'false';
 }

 function lockScroll() {
 if (window.LabooScrollLock) {
 window.LabooScrollLock.lock('ls-promo-v2-open');
 return;
 }
 document.documentElement.classList.add('ls-promo-v2-open');
 }

 function unlockScroll() {
 if (window.LabooScrollLock) {
 window.LabooScrollLock.unlock('ls-promo-v2-open');
 return;
 }
 document.documentElement.classList.remove('ls-promo-v2-open');
 }

 function tick() {
 var current = Date.now();
 var end = readStoredEnd();

 if (end === null) {
 end = current + DURATION_MS;
 writeStoredEnd(end);
 }

 var remainingMs = end - current;
 if (remainingMs <= 0) {
 end = current + DURATION_MS;
 writeStoredEnd(end);
 remainingMs = DURATION_MS;
 }

 var totalSeconds = Math.floor(remainingMs / 1000);
 var days = Math.floor(totalSeconds / 86400);
 var hours = Math.floor((totalSeconds % 86400) / 3600);
 var minutes = Math.floor((totalSeconds % 3600) / 60);
 var seconds = totalSeconds % 60;

 setUnit('days', pad2(days));
 setUnit('hours', pad2(hours));
 setUnit('minutes', pad2(minutes));
 setUnit('seconds', pad2(seconds));
 }

 function setUnit(name, value) {
 var node = getUnit(name);
 if (node) {
 node.textContent = value;
 }
 }

 function openPromo(opener) {
 var modal = getModal();
 if (!modal || modal.getAttribute('aria-hidden') === 'false') return;

 modal.setAttribute('aria-hidden', 'false');
 var strip = opener || getStrip();
 if (strip) {
 if (modal.id) strip.setAttribute('aria-controls', modal.id);
 strip.setAttribute('aria-expanded', 'true');
 }
 lockScroll();
 tick();
 setInitialFocus(modal);
 window.__lsPromoV2Opener = opener || null;
 }

 function closePromo() {
 var modal = getModal();
 if (!modal || modal.getAttribute('aria-hidden') === 'true') return;

 modal.setAttribute('aria-hidden', 'true');
 var strip = getStrip();
 if (strip) {
 strip.setAttribute('aria-expanded', 'false');
 }
 unlockScroll();

 var opener = window.__lsPromoV2Opener;
 window.__lsPromoV2Opener = null;
 if (opener && typeof opener.focus === 'function') {
 opener.focus({ preventScroll: true });
 }
 }

 function setInitialFocus(modal) {
 var close = modal.querySelector('[data-ls-promo-v2-close]');
 if (close && typeof close.focus === 'function') {
 close.focus({ preventScroll: true });
 } else if (typeof modal.focus === 'function') {
 modal.focus({ preventScroll: true });
 }
 }

 function getFocusable(modal) {
 if (!modal) return [];
 var selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
 var nodes = modal.querySelectorAll(selector);
 var list = [];
 for (var i = 0; i < nodes.length; i++) {
 list.push(nodes[i]);
 }
 return list;
 }

 function onKeydown(event) {
 if (event.key !== 'Tab') return;
 var modal = getModal();
 if (!modal || modal.getAttribute('aria-hidden') === 'true') return;

 var focusable = getFocusable(modal);
 if (focusable.length === 0) return;

 var first = focusable[0];
 var last = focusable[focusable.length - 1];

 if (event.shiftKey && document.activeElement === first) {
 event.preventDefault();
 last.focus();
 } else if (!event.shiftKey && document.activeElement === last) {
 event.preventDefault();
 first.focus();
 }
 }

 function wireEvents() {
 document.addEventListener('click', function (event) {
 var strip = (event.target && typeof event.target.closest === 'function')
 ? event.target.closest('.laboo-offer-strip')
 : null;
 if (!strip) return;

 event.preventDefault();
 event.stopPropagation();

 openPromo(strip);
 }, true);

 document.addEventListener('click', function (event) {
 if (!isOpen()) return;
 var closeEl = (event.target && typeof event.target.closest === 'function')
 ? event.target.closest('[data-ls-promo-v2-close]')
 : null;
 if (closeEl) {
 closePromo();
 }
 });

 document.addEventListener('keydown', function (event) {
 if (event.key === 'Escape' && isOpen()) {
 closePromo();
 }
 });

 document.addEventListener('keydown', onKeydown);

 document.addEventListener('visibilitychange', function () {
 if (!document.hidden) {
 tick();
 }
 });

 }

 function init() {
 if (initialized) return;
 initialized = true;

 wireEvents();
 tick();
 if (intervalId) {
 clearInterval(intervalId);
 }
 intervalId = setInterval(tick, 1000);
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', init);
 } else {
 init();
 }
})();
